<template>
    <div>

        <section class="index-header">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-9">
                        <div class="index-header__header">
                            <h1
                                style="opacity: 0;"
                                id="index-header__header"
                                v-observe-visibility="{
                                    callback: visibilityChanged,
                                    throttle: 0,
                                    once: true
                                }">
                                <span class="text-best">BEST</span> <span class="text-meta">META</span> makes it easy to browse the most popular products on Amazon.
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="(1 === 2)" class="main-search-section" id="main-search-section">
            <div class="container">

                <div class="row justify-content-center mb-2">

                   <div class="col-lg-6">
                       <div class="popular-searches-header">
                           (Star) Popular Searches
                       </div>

                       <div class="popular-searches-wrapper">

                           <div v-for="(search, i) in popularSearches" :key="i" @click="popularSearchesClicked(search)" class="popular-searches-wrapper__item">
                               <div class="popular-searches-wrapper__item__icon">
                                   (Search)
                               </div>
                               <div class="popular-searches-wrapper__item__content">{{search.query}}</div>
                           </div>

                       </div>
                   </div>

                </div>

                <div class="row justify-content-center mb-2">
                    <div class="col-lg-6">
                        <div class="input-wrapper">
                            <label class="input-wrapper__label input-wrapper__label--white" for="componentSelection-query">
                                First, choose a category
                                <a v-if="componentSelection.category" href @click.prevent="clearCategorySelection('category')" class="input-wrapper__clear-button" title="Clear">
                                    (Times Circle)
                                </a>
                            </label>
                            <multiselect
                                v-model="componentSelection.category"
                                :options="nestedAllCategories"
                                placeholder="Example: Electronics"
                                :label="'name'"
                                :track-by="'browseNodeId'"
                                :option-height="104"
                                @input="componentSelectionCategoryChanged"
                                :close-on-select="true"
                            >
                                <template slot="singleLabel" slot-scope="props">
                                    <div class="category-label-select-wrapper">
                                        <category-label
                                            :key="props.option.browseNodeId"
                                            :category="props.option"
                                            :type="'category'"
                                        ></category-label>
                                    </div>
                                </template>
                                <template slot="option" slot-scope="props"></template>
                            </multiselect>
                            <div class="input-wrapper__error-message input-wrapper__error-message--white" v-if="$v.componentSelection.category.$error">(Exclamation Circle) Please choose a main category.</div>
                        </div>
                    </div>
                </div>

                <div v-if="componentSelection.category" class="row justify-content-center mb-2">
                    <div class="col-lg-6">
                        <div class="input-wrapper">
                            <label class="input-wrapper__label input-wrapper__label--white" for="componentSelection-query">
                                Next, enter the product you're looking for (Optional)
                                <a v-if="componentSelection.query" href @click.prevent="componentSelection.query = null" class="input-wrapper__clear-button" title="Clear">
                                    (Times Circle)
                                </a>
                                <br> <small>(Info Circle) Leave this empty to see results from your selected category.</small>
                                <br> <small>(Info Circle) If your results are too broad then make your search query more specific.</small>
                            </label>
                            <div class="input-group input-group-lg mb-2">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="componentSelection-query"
                                    name="componentSelection-query"
                                    aria-describedby="componentSelection-query-help"
                                    v-model.trim="componentSelection.query"
                                    placeholder="Example: Laptop"
                                    @keyup.enter="mainSearchButtonClicked"
                                >
                            </div>
                            <div id="componentSelection-query-help" class="sr-only">Find your best-selling product</div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center mb-4">
                    <div v-if="componentSelection.category" class="col-lg-6">
                        <div class="input-wrapper">
                            <label class="input-wrapper__label input-wrapper__label--white" for="componentSelection-query" title="Clear">
                                Choose a subcategory to narrow it down further (Optional)
                                <a v-if="componentSelection.subcategory" href @click.prevent="clearCategorySelection('subcategory')" class="input-wrapper__clear-button">
                                    (Times Circle)
                                </a>
                            </label>
                            <multiselect
                                v-if="componentSelection.category"
                                v-model="componentSelection.subcategory"
                                :options="componentSelection.category.children"
                                placeholder="Example: Computers & Accessories"
                                :label="'name'"
                                :track-by="'browseNodeId'"
                                :option-height="104"
                                :disabled="!componentSelection.category"
                                :close-on-select="true"
                            >
                                <template slot="singleLabel" slot-scope="props">
                                    <div class="category-label-select-wrapper">
                                        <category-label
                                            :key="props.option.browseNodeId"
                                            :category="props.option"
                                            :type="'category'"
                                        ></category-label>
                                    </div>
                                </template>
                                <template slot="option" slot-scope="props"></template>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center mb-5">
                    <div class="col-lg-4">
                        <button
                            @click="mainSearchButtonClicked"
                            title="Search Products"
                            class="btn btn-orange btn-lg btn-block"
                            type="button"
                            id="componentSelection-submit-button"
                            :disabled="!componentSelection.category"
                        >
                            <span v-if="!isLoadingProducts">
                                (Search) Search
                            </span>

                            <span v-if="isLoadingProducts">
                                (Cog) Searching
                            </span>
                        </button>
                    </div>
                </div>

                <div class="row justify-content-center mb-4">
                    <div class="col-lg-5">

                        <label for="currency-select" class="small text-white">(Money Bill)&nbsp; Choose your currency formatting. Please note that the price shown in the product panels may be different than what is shown on Amazon due to price changes or currency conversion changes.</label>
                        <select
                            name="currency-select"
                            id="currency-select"
                            v-model="componenetSelectedCurrency"
                            class="form-control"
                            >
                            <option v-for="currency in currencyArray" :key="currency.name" :value="currency">{{currency.name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-lg-4">
                        <div class="small text-white text-center">
                            (Info Circle) Best Meta conducts searches based on the best-selling, most popular, and best reviewed products based on what category information is available.
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <!-- <vue-programmatic-invisible-google-recaptcha
            ref="invisibleRecaptcha1"
            :sitekey="'6LcmkHsUAAAAAF1aW4L1ISgWg120_Kk17erSWcMo'"
            :elementId="'invisibleRecaptcha1'"
            :badgePosition="'left'"
            :showBadgeMobile="false"
            :showBadgeDesktop="false"
            @recaptcha-callback="mainSearchRecaptchaCallback"
        ></vue-programmatic-invisible-google-recaptcha> -->

        <section v-if="isLoadingProducts && !products.length" class="product-section"  id="product-section">
            <div class="container">
                <div  class="row mt-5">
                    <div v-for="index in 6" :key="index" class="col-lg-4 mb-5">
                        <content-loader
                            :height="500"
                            :width="350"
                            :speed="2"
                            primaryColor="#eaebec"
                            secondaryColor="#dcddde"
                        >
                            <rect x="0" y="0" rx="5" ry="5" width="350" height="500" />
                        </content-loader>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="products.length" class="product-section" id="product-section">
            <div class="container">

                <div class="product-section__header">
                    Viewing <strong>{{ (10 > paaInfo.totalResults) ? paaInfo.totalResults : (componentSelection.page * 10) }}</strong> of <strong>{{paaInfo.totalResults}}</strong>
                </div>

                <button
                    @click="tryAnotherSearch"
                    class="btn btn-purple btn-xs mb-4"
                >
                    (Undo)
                    Try another search
                </button>

                <transition-group name="slide-fade" mode="out-in" tag="div" v-if="products.length" class="row mb-3">
                    <product
                        v-for="(product, i) in products"
                        :key="product.ASIN + i"
                        :product="product"
                        :index="i + 1"
                        :selectedCurrency="componenetSelectedCurrency"
                    ></product>
                </transition-group>

                <div v-if="(componentSelection.page * 10) < paaInfo.totalResults" class="text-center">
                    <button
                        class="btn btn-purple btn-lg mb-2"
                        @click="loadMoreButtonClicked"
                        :disabled="isLoadingProducts"
                    >
                        <span v-if="!isLoadingProducts">
                            (Arrow Alt Down) Load More
                        </span>

                        <span v-if="isLoadingProducts">
                            (Cog) Loading
                        </span>
                    </button>

                    <div v-if="!isLoadingProducts" class="small">
                        Viewing <strong>{{componentSelection.page * 10}}</strong> of <strong>{{paaInfo.totalResults}}</strong>
                    </div>
                </div>

                <div v-if="(componentSelection.page * 10) > paaInfo.totalResults && !isLoadingProducts" class="text-center">
                    Looks like that's the end of the road. Want to <a href @click.prevent="tryAnotherSearch">try another search?</a>
                </div>

            </div>
        </section>

        <section v-if="!isLoadingProducts && noProductsFound" class="no-products-found-section" id="product-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="no-products-found-wrapper">
                            <div class="no-products-found-wrapper__text">
                                Hmm, we couldn't find any products for that search. Sorry about that!
                            </div>

                            <button @click.prevent="tryAnotherSearch" class="btn btn-purple btn-block" >Try another search</button>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="content-card-section content-card-section--white-background">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h1 class="content-card-section__header content-card-section__header--dark">Buying A Gift?</h1>
                    </div>
                </div>

                <div class="row">
                    <div
                        v-if="[
                            'https://blog.bestmeta.com/tips-for-buying-gifts/',
                            'https://blog.bestmeta.com/must-have-game-of-thrones-gift-ideas/',
                            'https://blog.bestmeta.com/gift-ideas-for-sneaker-heads/',
                            'https://blog.bestmeta.com/gift-ideas-for-your-mother/',
                            'https://blog.bestmeta.com/gift-ideas-for-sports-fans/',
                            'https://blog.bestmeta.com/gift-ideas-for-your-friend-who-loves-instagram/'
                        ]
                        .includes(content.link)"
                        v-for="content in contentList"
                        :key="content.title"
                        class="col-lg-4"
                    >
                        <div class="content-card-wrapper content-card-wrapper--white-background">
                            <a :href="content.link" target="_blank">
                                <img :src="content.thumbnail" class="img-fluid content-card-wrapper__image" :alt="content.title">
                            </a>
                            <div class="content-card-wrapper__description">{{ content.description | truncate(100) }}</div>
                            <a :href="content.link" class="content-card-wrapper__link" target="_blank">Visit Page</a>
                        </div>
                    </div>
                </div>

                <!-- <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="panel panel--grey">
                            Visit <a href="https://browsenodes.bestmeta.com" target="_blank">browsenodes.bestmeta.com</a> if you'd like to download Best Meta's BrowseNodes list for use in your own app!
                        </div>
                    </div>
                </div> -->
            </div>
        </section>

        <social-sharing
            url="https://www.bestmeta.com/"
            title="Best Meta"
            description="Best Meta - Browse the best products the internet has to offer."
            quote="Buying Christmas gifts has never been easier."
            hashtags="bestmeta"
            inline-template>

            <div class="social-sharing-section">
                <div class="container">
                    <div class="row justify-content-center">

                        <div class="col-lg-12 social-sharing-section__header">Share</div>

                        <div class="col-3 col-md-2">
                            <network network="email" class="social-sharing-section__item">
                                <span class="social-sharing-section__item__title">Email</span>
                            </network>
                        </div>
                        <div class="col-3 col-md-2">
                            <network network="twitter" class="social-sharing-section__item">
                                <span class="social-sharing-section__item__title">Twitter</span>
                            </network>
                        </div>
                        <div class="col-3 col-md-2">
                            <network network="facebook" class="social-sharing-section__item">
                                <span class="social-sharing-section__item__title">Facebook</span>
                            </network>
                        </div>
                        <div class="col-3 col-md-2">
                            <network network="reddit" class="social-sharing-section__item">
                                <span class="social-sharing-section__item__title">Reddit</span>
                            </network>
                        </div>
                    </div>
                </div>
            </div>
        </social-sharing>

        <general-header
            v-bind:content="{
                header: 'Search for what\'s popular',
                subheader: 'Use the search box to find what you\'re looking for. <br> Buying Christmas gifts has never been easier.',
                buttonText: '',
                buttonIcon: '',
                iconPosition: '',
                to: ''
            }">
        </general-header>

        <div id="amzn-assoc-ad-dd5e64a8-ac6c-4184-9c62-a341f804d52e" ref="scriptHolder"></div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { ContentLoader } from 'vue-content-loader'
import jump from 'jump.js'
import { purple } from '@/common/colors'
import contentList from '@/data/best-meta-blog-info.json'

export default {
    name: 'home',
    data () {
        return {
            componentSelection: {
                query: null,
                category: null,
                subcategory: null,
                page: 1
            },
            isLoadingProducts: false,
            noProductsFound: false,
            contentList: contentList,
            popularSearches: [
                {
                    query: 'tablet',
                    category: 'Electronics',
                    subcategory: 'Computers & Accessories'
                },
                {
                    query: 'leggings',
                    category: 'Clothing, Shoes & Jewelry - Women',
                    subcategory: 'Clothing'
                },
                {
                    query: 'cat food',
                    category: 'Pet Supplies',
                    subcategory: null
                },
                {
                    query: 'electric guitar',
                    category: 'Musical Instruments',
                    subcategory: 'Guitars'
                },
                {
                    query: 'kids toys',
                    category: 'Toys & Games',
                    subcategory: null
                },
                {
                    query: 'juicer',
                    category: 'Home & Kitchen',
                    subcategory: 'Kitchen Utensils & Gadgets'
                },
                {
                    query: 'ps4 bundle',
                    category: 'Video Games',
                    subcategory: 'Playstation 4'
                },
                {
                    query: 'headphones',
                    category: 'Electronics',
                    subcategory: 'Headphones'
                },
            ],
            componenetSelectedCurrency : {
                "symbol": "$",
                "name": "US Dollar",
                "symbol_native": "$",
                "decimal_digits": 2,
                "rounding": 0,
                "code": "USD",
                "name_plural": "US dollars"
            }
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            nestedAllCategories: 'products/nestedAllCategories',
            rootCategories: 'products/rootCategories',
            products: 'products/products',
            paaInfo: 'products/paaInfo',
            selection: 'products/selection',
            selectedCurrency: 'products/selectedCurrency',
            currencyArray: 'products/currencyArray'
        }),
    },
    methods: {
        async mainSearchRecaptchaCallback (token) {
            // this.$nextTick(async () => {
            //     await jump(document.getElementById('product-section'),{duration: 500})
            // })

            // this.submitMainSearch()
        },
        async mainSearchButtonClicked () {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            this.isLoadingProducts = true

            this.$nextTick(async () => {
                await jump(document.getElementById('product-section'),{duration: 500})
            })

            this.submitMainSearch()

            // this.$refs.invisibleRecaptcha1.execute()
        },
        async submitMainSearch () {
            try {
                // Main search should always set the page number back to 1
                this.componentSelection.page = 1

                await this.$store.dispatch('products/removeItems')
                let productResults = await this.$store.dispatch('products/getItems', {selection: this.componentSelection})

                // We're only grabbing the products here to see if the result was empty -
                // that way we can show the `noProductsFound` section
                if (!productResults.length) {
                    this.noProductsFound = true
                } else {
                    this.noProductsFound = false
                }

                // Rebuild the amazon script so the links go to other locales
                this.buildAmazonOneLinkJavascript()

                this.$ga.event('click', 'click', 'Successful Main Search')
            } catch (error) {
                this.$ga.event('click', 'click', 'Error Main Search - ' + error.toString())
                this.$toasted.error('There was an error connecting to the server. Please try again.')
            } finally {
                this.isLoadingProducts = false
            }
        },

        componentSelectionCategoryChanged (value, id) {
            this.componentSelection.subcategory = null
            if (this.componentSelection.category) {
                this.animateCategorySearchButton()
            }
        },
        async loadMoreButtonClicked () {
            this.componentSelection.page++
            try {
                this.isLoadingProducts = true
                await this.$store.dispatch('products/getItems', {selection: this.componentSelection})

                // Rebuild the amazon script so the links go to other locales
                this.buildAmazonOneLinkJavascript()
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server. Please try again.')
            } finally {
                this.isLoadingProducts = false
            }
        },

        tryAnotherSearch () {
            this.$ga.event('click', 'click', 'Try Another Search')
            this.$nextTick(async () => {
                await jump(document.getElementById('main-search-section'),{duration: 500, offset: -50})
            })
        },

        async animateCategorySearchButton () {
            await this.$animejs({
                targets: '#componentSelection-submit-button',
                backgroundColor: [
                    {value: purple}
                ],
                easing: 'linear',
                direction: 'alternate',
                delay: 100,
                duration: 100
            }).finished
            await this.$animejs({
                targets: '#componentSelection-submit-button',
                backgroundColor: [
                    {value: purple}
                ],
                easing: 'linear',
                direction: 'alternate',
                delay: 0,
                duration: 50
            }).finished
        },

        clearCategorySelection (type) {
            if (type === 'category') {
                this.componentSelection.category = null
                this.componentSelection.subcategory = null
            }

            if (type === 'subcategory') {
                this.componentSelection.subcategory = null
            }
        },

        async popularSearchesClicked(search) {
            let categoryResult = this.nestedAllCategories.find((element) => {
                return element.name === search.category
            })

            let subcategoryResult
            if (search.subcategory) {
                subcategoryResult = categoryResult.children.find((element) => {
                    return element.name === search.subcategory
                })
            }

            this.componentSelection.query = search.query
            this.componentSelection.category = categoryResult
            this.componentSelection.subcategory = subcategoryResult

            await this.mainSearchButtonClicked()
        },

        async visibilityChanged (isVisible, entry) {
            // Fade up
            if ( isVisible && (entry.target.id === 'index-header__header') ) {
                await this.$animejs({
                    targets: '#' + entry.target.id,
                    duration: 0,
                    opacity: 0,
                    translateY: 50,
                    easing: 'linear'
                }).finished

                await this.$animejs({
                    targets: '#' + entry.target.id,
                    scale: 1.0,
                    duration: 2000,
                    opacity: 1,
                    translateY: 0,
                    easing: 'easeOutElastic',
                    delay: 0
                }).finished
            }

            // // Fade up
            // if ( isVisible && (entry.target.id === 'main-search-section__container') ) {
            //     await this.$animejs({
            //         targets: '#' + entry.target.id,
            //         duration: 0,
            //         opacity: 0,
            //         translateY: 50,
            //         easing: 'linear'
            //     }).finished

            //     await this.$animejs({
            //         targets: '#' + entry.target.id,
            //         scale: 1.0,
            //         duration: 2000,
            //         opacity: 1,
            //         translateY: 0,
            //         easing: 'easeOutElastic',
            //         delay: 200
            //     }).finished
            // }
        },

        buildAmazonOneLinkJavascript () {
            let scriptEl = document.createElement('script')
            scriptEl.setAttribute('src', '//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=dd5e64a8-ac6c-4184-9c62-a341f804d52e')
            scriptEl.async = true
            this.$refs.scriptHolder.appendChild(scriptEl)
        }
    },
    async mounted () {
        // We can tell the selection is filled by checking the category
        // because category is required
        if (this.selection.category) {
            this.componentSelection = Object.assign({}, this.selection)
        }

        // Check selected currency
        if (this.selectedCurrency) {
            this.componenetSelectedCurrency = Object.assign({}, this.selectedCurrency)
        }
    },
    created () {
    },
    watch: {
        componentSelection: {
            handler: function (value) {
                this.$store.commit('products/UPDATE_SELECTION', value)
            },
            deep: true
        },
        componenetSelectedCurrency: {
            handler: function (value) {
                this.$store.commit('products/UPDATE_SELECTED_CURRENCY', value)
            },
            deep: true
        }
    },
    components: {
        ContentLoader
    },
    validations: {
        componentSelection: {
            category: {
                required
            }
        }
    },
    metaInfo () {
        return {
            title: this.$route.meta.title,
            link: [
                {rel: 'canonical', href: 'https://www.bestmeta.com'},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
     @import '~@/assets/css/components/_variables.scss';

    .index-header {
        padding: 35px 0;
        // background: url('~@/assets/images/artwork/index-background.svg');
        background: $white;
        background-size: cover;
        background-position: 50% 50%;
        background-attachment: fixed;
        background-repeat: repeat;

        @media (min-width: 992px) {
            padding: 85px 0;
        }

        &__header {
            text-align: left;

            @media (min-width: 992px) {
                text-align: center;
            }
        }

        .text-best {
            color: $orange;
        }
        .text-meta {
            color: $purple;
        }
    }

    .main-search-section {
        padding: 35px 0;
        background: $purple;
    }

    .product-section {
        padding: 25px 0 55px;
        background: $off-white;

        &__header {
            font-size: 1.2rem;
            margin-bottom: 20px;
        }
    }

    .no-products-found-section {
        padding: 55px 0;

        .no-products-found-wrapper {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            text-align: left;
            width: 100%;
            padding: 40px;
            background: $off-white;
            margin: 0 auto;

            @media (min-width: 992px) {
                width: 50%;
            }

            &__icon {
                font-size: 5rem;
                margin-bottom: 20px;
                margin-left: auto;
                margin-right: auto;
            }

            &__text {
                font-size: 1.1rem;
                margin-bottom: 30px;
                text-align: left;
            }
        }
    }

    .content-card-section {
        padding: 50px 0 50px;
        border-bottom: $border;

        &--purple-background {
            background: $purple;
        }

        &__header {
            text-transform: uppercase;
            text-align: center;
            margin-bottom: 45px;

            &--light {
                color: $white;
            }

            &--dark {
                color: $purple;
            }
        }
    }

    .content-card-wrapper {
        padding: 20px;
        border-radius: 6px;
        box-shadow: $box-shadow;
        margin-bottom: 50px;
        border: $border;

        display: flex;
        flex-direction: column;

        &--grey-background {
            background-color: $grey;
        }

        &--white-background {
            background-color: $white;
        }

        &__image {
            margin-bottom: 15px;
            transition: $transition;

            &:hover {
                opacity: 0.9;
            }
        }

        &__title {
            font-size: 1.6rem;
            line-height: 1.3;
            color: $purple;
            margin-bottom: 10px;
            font-weight: bold;

            &:hover {
                text-decoration: none;
                color: $dark-purple;
            }
        }

        &__description {
            margin-bottom: 10px;
        }

        &__link {
            margin-left: auto;
            display: flex;
            align-items: center;
            margin-top: auto;
            text-align: right;
            font-size: 0.8rem;
            color: $white;
            background: $orange;
            padding: 8px 12px;
            border-radius: 6px;
            transition: $transition;
            text-transform: uppercase;
            font-weight: bold;

            svg {
                margin-left: 5px;
            }

            &:hover {
                color: $white;
                text-decoration: none;
                background: darken($orange, 5%);
            }
        }
    }

    .popular-searches-header {
        color: $white;
        font-weight: bold;
        width: 100%;
        margin-bottom: 10px;
    }

    .popular-searches-wrapper {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        flex-wrap: wrap;

        @media (min-width: 768px) {
            flex-direction: row;
        }

        &__item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            background: $orange;
            padding: 4px 12px;
            border-radius: 4px;
            cursor: pointer;
            transition: $transition;
            flex-wrap: wrap;

            &:hover {
                background: darken($orange, 10%);
            }

            &:not(last-of-type) {
                margin-right: 10px;
                margin-bottom: 10px;
            }

            &__icon {
                color: $white;
                font-size: 0.6rem;
                margin-right: 5px;

                @media (min-width: 992px) {
                    font-size: 0.8rem;
                }
            }

            &__content {
                color: $white;
            }
        }
    }
</style>
